import React from 'react'
import { useLocation } from 'react-router-dom'

import CreateUserRoleGrant from '../../../components/CreateUserRoleGrant'
import ContextMenu from '../../../components/ContextMenu'

export default function () {
  const query = new URLSearchParams(useLocation().search)
  const organizationId = parseInt(query.get('organizationId'))
  const roleId = parseInt(query.get('roleId'))

  return (
    <div className='container'>
      <ContextMenu
              renderTitle={() => (
                <h1 className="title">Create a new grant</h1>
              )}
            ></ContextMenu>
      <CreateUserRoleGrant organizationId={organizationId} roleId={roleId} />
    </div>
  )
}
